import { FormDataModel } from '@/model/FormModel'

export const FromFieldData: FormDataModel[] = [
  {
    title: '开票信息',
    type: 1,
    labelClass: 'green',
    labelName: '发',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'titleName',
        fieldName: '公司名称',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'taxId',
        fieldName: '税号',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'registeredAddress',
        fieldName: '注册地址',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'bank',
        fieldName: '开户银行',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'account',
        fieldName: '银行账号',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'phone',
        fieldName: '电话号码',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }
    ]
  }
]
